import { render, staticRenderFns } from "./IdentifyPage.vue?vue&type=template&id=3ee94392&scoped=true"
import script from "./IdentifyPage.vue?vue&type=script&lang=js"
export * from "./IdentifyPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ee94392",
  null
  
)

export default component.exports